module.exports = __webpack_public_path__ + "img/new-inquiry.93df267c.svg";